import React from 'react';
import DatePicker from 'react-datepicker';

interface TodayButtonProps {
  disabled?: boolean;
  onTodayButtonClick: () => void;
  defaultSelected?: Date | null;
  setDatePickerDate: React.Dispatch<React.SetStateAction<Date | null | undefined>>;
  datepickerRef: React.RefObject<React.ElementRef<typeof DatePicker>>;
}

const TodayButton: React.FC<TodayButtonProps> = ({
  disabled,
  onTodayButtonClick,
  defaultSelected,
  setDatePickerDate,
  datepickerRef,
  ...props
}) => (
  <div onClick={(e) => e.stopPropagation()} className='today-button__wrapper'>
    <button
      className='today-button__button'
      data-testid='act-datepicker--today-button'
      data-testid-e2e='act-datepicker--today-button'
      disabled={disabled}
      type='button'
      onClick={(e) => {
        e.stopPropagation();
        setDatePickerDate(defaultSelected);
        onTodayButtonClick();
        datepickerRef.current?.setOpen(false);
      }}
      {...props}>
      今日
    </button>
  </div>
);

export default TodayButton;
